import { clsx } from 'clsx'
import { HTMLAttributes, ReactNode } from 'react'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  variant?: 'default' | 'gradient' | 'custom'
  width?: 'contained' | 'full'
  color?: string
  children: ReactNode
}

export function Container({
  className,
  variant = 'default',
  width = 'contained',
  color,
  children,
  ...props
}: ContainerProps) {
  const getBackgroundStyle = () => {
    if (variant === 'custom' && color) {
      return {
        className: 'text-white',
        style: { backgroundColor: color },
      }
    }

    if (variant === 'gradient') {
      return {
        className: 'bg-gradient-to-r from-[#62cadd] to-[#2e76bc] text-white',
        style: undefined,
      }
    }

    return {
      className: 'bg-white text-text-primary',
      style: undefined,
    }
  }

  const backgroundConfig = getBackgroundStyle()

  return (
    <section className={clsx(backgroundConfig.className)} style={backgroundConfig.style}>
      <div
        className={clsx(
          width === 'contained' ? 'mx-auto max-w-7xl px-4 sm:px-6 lg:px-8' : 'w-full',
          'text-left',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </section>
  )
}

export default Container
